import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../utils/api";

export default function ChangePassword({
  user,
  onPasswordChanged,
  requireCurrentPassword = false,
  allowCancel = false
}) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }

    setLoading(true);

    try {
      const response = await apiFetch(
        requireCurrentPassword
          ? "/auth/change-password-with-current"
          : "/auth/change-password",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token}`
          },
          body: JSON.stringify(
            requireCurrentPassword
              ? { currentPassword, newPassword }
              : { newPassword }
          )
        }
      );

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || "Failed to change password");
        return;
      }

      onPasswordChanged();
    } catch {
      setError("An error occurred");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="change-password-page">
      <form className="change-password-form" onSubmit={handleSubmit}>
        <h2>
          {requireCurrentPassword
            ? "Change Password"
            : "Welcome — Set Your Password"}
        </h2>
        {requireCurrentPassword && (
          <input
            type="password"
            placeholder="Current password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        )}

        <input
          type="password"
          placeholder="New password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Confirm password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : "Save Password"}
        </button>
          {allowCancel && (
            <button
              type="button"
              className="secondary-btn"
              onClick={() => navigate("/admin")}
            >
              Cancel
          </button>
          )}

        {error && <p className="error-text">{error}</p>}
      </form>
    </div>
  );
}
